import { Typography, Button } from 'antd';
import { format } from 'date-fns';
import FileSaver from 'file-saver';
import React, { useState, useEffect } from 'react';

import GachaRegisterTable from '@/GachaRegister/components/GachaRegisterTable';
import { GachaRegister } from '@/api-client/generated/models';
import { useGacha } from '@/hooks/context/GachaContext';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

const dateFormat = 'yyyy/MM/dd HH:mm:ss';
const PER_PAGE = 50; // 設定する必要があるかわからんので 50 でいったん固定（サーバー側も）

const ListGachaRegister: React.FC<{}> = () => {
  const api = createApiClientWithToken();
  const [gachaRegisters, setGachaRegisters] = useState<GachaRegister[]>([]);
  const [gachaRegistersNum, setGachaRegistersNum] = useState<number>(0);
  const [os, setOs] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchWord, setSearchWord] = useState<string>('');
  const { gacha } = useGacha();
  const listGachaRegisters = async (perPage: number, offset: number, _os: string, _searchWord: string) =>
    api.listGachaRegisterPerGame(gacha.id as string, {
      limit: perPage,
      offset,
      os: _os,
      searchWord: _searchWord,
    });

  useEffect(() => {
    listGachaRegisters(PER_PAGE, 0, os, searchWord).then((response) => {
      setGachaRegisters(response.registers ?? []);
      setGachaRegistersNum(response.totalNum ?? 0);
    });
  }, []);

  const onChangeCurrentPage = async (newPage: number) => {
    setCurrentPage(newPage);
    const response = await listGachaRegisters(PER_PAGE, (newPage - 1) * PER_PAGE, os, searchWord); // index 調整のため -1
    setGachaRegisters(response.registers ?? []);
  };

  const onChangeOs = async (_os: string) => {
    setOs(_os);
    const response = await listGachaRegisters(PER_PAGE, 0, _os, searchWord);
    setGachaRegisters(response.registers ?? []);
    setCurrentPage(1);
    setGachaRegistersNum(response.totalNum ?? 0);
  };

  const onSearch = async (word: string) => {
    setSearchWord(word);
    const response = await listGachaRegisters(PER_PAGE, 0, os, word);
    setGachaRegisters(response.registers ?? []);
    setCurrentPage(1);
    setGachaRegistersNum(response.totalNum ?? 0);
  };

  const exportCsv = async () => {
    const response = await api.listAllGachaRegisterPerGame(gacha.id as string);
    if (typeof response.registers === 'undefined') return;

    const headers = ['ユーザ名', 'メールアドレス', 'OS', '登録日'];
    const body = response.registers.map((register) => {
      if (typeof register.user === 'undefined') return [];

      return [
        register.user.nickname,
        register.user.mailAddress,
        register.os,
        format(register.createdAt as Date, dateFormat),
      ];
    });
    const csvRows = [headers, ...body];
    const csv = csvRows.map((row) => row.join(',')).join('\r\n');

    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, csv], { type: 'text/csv' });
    FileSaver.saveAs(blob, `${gacha.name}-事前登録者一覧-${format(Date.now(), dateFormat)}.csv`);
  };

  return (
    <div>
      <Typography.Title>事前登録者一覧</Typography.Title>
      <Button onClick={exportCsv}>全データのCSVエクスポート</Button>
      <GachaRegisterTable
        gachaRegisters={gachaRegisters}
        gachaRegistersNum={gachaRegistersNum}
        currentPage={currentPage}
        perPage={PER_PAGE}
        onChangeCurrentPage={onChangeCurrentPage}
        onChangeOs={onChangeOs}
        onSearch={onSearch}
      />
    </div>
  );
};

export default ListGachaRegister;
